import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { AuthSsoCallbackControllerModule } from './controllers/SsoCallbackController';
import { AuthSsoControllerModule } from './controllers/SsoController';

export const SsoView = angular
  .module('acme.view.auth.sso', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    AuthSsoControllerModule,
    AuthSsoCallbackControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'auth.sso_continue',
      url: '/sso/continue?RelayState',
      views: {
        'subview-main': {
          controller: 'SsoCallbackController',
          controllerAs: '$ctrl',
          templateUrl: 'views/auth/sso/sso-callback.tpl.html',
        },
      },
    });
  }).name;
